import * as Yup from "yup";

export const formData = {
  name: "",
  officer: "",
  premises: "",
  reason: "",
  PurposeVisit: "",
};

function validationSchema(customFields) {
  const generateFieldSchema = (field) => {
    let schema;

    switch (field.value_type) {
      case "string":
        schema = Yup.string();
        if (field.regex) {
          schema = schema.matches(
            new RegExp(field.regex),
            field.error_message || "Invalid format"
          );
        }
        break;

      case "boolean":
        schema = Yup.boolean();
        break;

      case "list":
        schema = Yup.array();
        break;

      default:
        schema = Yup.mixed(); // fallback
    }

    if (field.mandatory) {
      schema = schema.required(
        field.error_message || `${field.label} is required`
      );
    }

    return schema;
  };

  const dynamicVisitorSchemaShape = {};

  customFields.forEach((field) => {
    dynamicVisitorSchemaShape[field.name] = generateFieldSchema(field);
  });

  return Yup.object().shape({
    name: Yup.string()
      .required("name is required")
      .min(2, "Your name must be at least 2 characters"),
    officer: Yup.string().required("Officer is required"),
    PurposeVisit: Yup.string().required("Purpose of Visit is required"),
    reason: Yup.string().when("PurposeVisit", {
      is: "other",
      then: Yup.string().required("Reason is required"),
      otherwise: Yup.string(),
    }),
    // ...dynamicVisitorSchemaShape,
  });
}

export default validationSchema;
